import { Link, useLocation } from 'react-router-dom';
import React from 'react';

function OptionCalendarComponent() {

    const location = useLocation();
    const currentPath = location.pathname.split('/').pop();

    const isActive = (path) => currentPath === path;
    
    return (
        <>
            <div className="navigation-history justify-content-center">
                <Link to="day" className={`date-label teko ${isActive('day') ? 'active' : ''}`}>
                    DAY
                </Link>
                <Link to="week" className={`date-label teko ${isActive('week') ? 'active' : ''}`}>
                    WEEK
                </Link>
                <Link to="month" className={`date-label teko ${isActive('month') ? 'active' : ''}`}>
                    MONTH
                </Link>
                <Link to="year" className={`date-label teko ${isActive('year') ? 'active' : ''}`}>
                    YEAR
                </Link>
            </div>
        </>
    )
}

export default OptionCalendarComponent;
